import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { faCube, faPlus } from '@fortawesome/free-solid-svg-icons';

import Loader from 'components/Loader';
import { SidebarCategory, SidebarItem } from 'components/Sidebar';
import { makeSelectLocation } from 'containers/App/selectors';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import reducer from './reducer';
import saga from './saga';
import { loadData } from './actions';
import { REDUX_ROOT } from './constants';
import { makeSelectData, makeSelectError, makeSelectLoading } from './selectors';

export class AppsMenu extends Component {
  constructor(props) {
    super(props);

    let openAppID;
    if (props.location && props.location.pathname) {
      openAppID = parseInt(props.location.pathname.split('/')[2], 10);
    }
    this.state = { openAppID };
  }

  componentDidMount() {
    this.props.loadData();
  }

  toggle = id => {
    this.setState({
      openAppID: this.state.openAppID === id ? 0 : id,
    });
  };

  render() {
    const { items = [], data = [] } = this.props;

    if (!data) {
      return (
        <Fragment>
          <Loader inline />
        </Fragment>
      );
    }

    if (data && data.data && data.data.length === 0) {
      return (
        <Fragment>
          <SidebarItem icon={faPlus} name="Create your first app" to="/apps/create" />
        </Fragment>
      );
    }

    return (
      <Fragment>
        {data &&
          data.data &&
          data.data.map(app => (
            <SidebarCategory
              key={app.id}
              name={app.name}
              badgeColor={app.badgeColor}
              badgeText={app.badgeText}
              icon={faCube}
              to={app.path}
              isOpen={this.state.openAppID === app.id}
              onClick={() => this.toggle(app.id)}
            >
              {items.map((route, index) => {
                return (
                  !route.noMenu && (
                    <SidebarItem
                      key={index}
                      name={route.name}
                      to={{ pathname: route.path.replace(':id', app.id), state: app }}
                      badgeColor={route.badgeColor}
                      badgeText={route.badgeText}
                      appMenu
                    />
                  )
                );
              })}
            </SidebarCategory>
          ))}
      </Fragment>
    );
  }
}

const withReducer = injectReducer({ key: REDUX_ROOT, reducer });
const withSaga = injectSaga({ key: REDUX_ROOT, saga });

const mapStateToProps = createStructuredSelector({
  loading: makeSelectLoading(),
  error: makeSelectError(),
  data: makeSelectData(),
  location: makeSelectLocation(),
});

const mapDispatchToProps = {
  loadData,
};

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(AppsMenu);
